require('assets/global.scss')

require('./page.scss')

require('../../module/header/header.scss')
require('../../module/header/header.js')

require('../../module/profile-header/profile-header.scss')
require('../../module/profile-header/profile-header.js')
require('../../module/pannel-menu/pannel-menu.scss')
require('../../module/pannel-menu/pannel-menu.js')
require('../../module/pannel-comment/pannel-comment.scss')
require('../../module/pannel-comment/pannel-comment.js')
require('../../module/pannel-empty/pannel-empty.scss')
require('../../module/pannel-empty/pannel-empty.js')
require('../../module/right-toolbar/right-toolbar.scss')
require('../../module/right-toolbar/right-toolbar.js')
require('../../module/footer/footer.scss')
require('../../module/footer/footer.js')



// WEBPACK FOOTER //
// ./src/page/profile-pc-dianping/page.js